import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import { CartProvider } from './context/CartContext';
import { CurrencyProvider } from './context/CurrencyContext';
import { MessagesProvider } from './context/MessagesContext';
import Navbar from './components/Navbar';
import AnnouncementBar from './components/AnnouncementBar/AnnouncementBar';
import ProtectedRoute from './components/ProtectedRoute';

import Home    from './pages/Home';
import Profile from './pages/Profile';
import PublicProfile from './pages/PublicProfile';
import Settings from './pages/Settings';
import Upload  from './pages/Upload';
import BulkUpload from './pages/BulkUpload';
import Admin   from './pages/Admin';
import Listing from './pages/Listing';
import Cart    from './pages/Cart';
import Seller  from './pages/Seller';
import Terms   from './pages/Terms';
import Sorteo  from './pages/Sorteo';
import Pricing from './pages/Pricing';
import PremiumSuccess from './pages/PremiumSuccess';
import PurchaseSuccess from './pages/PurchaseSuccess';
import Messages from './pages/Messages';
import {
  Trigger, InviteCode, Waitlist, WaitlistDone, Login, Register, Registro,
} from './pages/Auth';

// Only show the public Navbar on home-like pages
const NO_NAV = ['/trigger','/invite','/waitlist','/waitlist/done','/login','/register','/registro'];

function Shell({ children }) {
  const { pathname } = useLocation();
  const hideNav = NO_NAV.some(p => pathname.startsWith(p));
  return (
    <>
      <AnnouncementBar />
      {!hideNav && <Navbar />}
      {children}
    </>
  );
}

export default function App() {
  return (
    <HelmetProvider>
      <ThemeProvider>
        <AuthProvider>
          <CurrencyProvider>
            <CartProvider>
              <MessagesProvider>
              <BrowserRouter>
              <Shell>
                <Routes>
                  {/* Public */}
                  <Route path="/"            element={<Home />} />
                  <Route path="/trigger"     element={<Trigger />} />
                  <Route path="/invite"      element={<InviteCode />} />
                  <Route path="/waitlist"    element={<Waitlist />} />
                  <Route path="/waitlist/done" element={<WaitlistDone />} />
                  <Route path="/login"       element={<Login />} />
                  <Route path="/register"    element={<Register />} />
                  <Route path="/registro"    element={<Registro />} />
                  <Route path="/listing/:id" element={<Listing />} />
                  <Route path="/u/:id"       element={<PublicProfile />} />
                  <Route path="/terminos"    element={<Terms />} />
                  <Route path="/terms"       element={<Terms />} />
                  <Route path="/sorteo"      element={<Sorteo />} />
                  {/* /rifa fue la URL original de la campaña: la conservamos
                      redirigida para no romper enlaces ya compartidos. */}
                  <Route path="/rifa"        element={<Navigate to="/sorteo" replace />} />
                  <Route path="/precios"     element={<Pricing />} />
                  <Route path="/pricing"     element={<Pricing />} />

                  {/* Protected */}
                  <Route path="/profile"  element={<ProtectedRoute><Profile /></ProtectedRoute>} />
                  <Route path="/premium/exito" element={<ProtectedRoute><PremiumSuccess /></ProtectedRoute>} />
                  <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
                  <Route path="/upload"      element={<ProtectedRoute><Upload /></ProtectedRoute>} />
                  <Route path="/upload/bulk" element={<ProtectedRoute><BulkUpload /></ProtectedRoute>} />
                  <Route path="/upload/:id"  element={<ProtectedRoute><Upload /></ProtectedRoute>} />
                  <Route path="/admin"    element={<ProtectedRoute><Admin /></ProtectedRoute>} />
                  <Route path="/cart"     element={<ProtectedRoute><Cart /></ProtectedRoute>} />
                  <Route path="/compra/exito" element={<ProtectedRoute><PurchaseSuccess /></ProtectedRoute>} />
                  <Route path="/seller"   element={<ProtectedRoute><Seller /></ProtectedRoute>} />
                  <Route path="/mensajes"     element={<ProtectedRoute><Messages /></ProtectedRoute>} />
                  <Route path="/mensajes/:id" element={<ProtectedRoute><Messages /></ProtectedRoute>} />

                  {/* Fallback */}
                  <Route path="*" element={<Home />} />
                </Routes>
              </Shell>
              </BrowserRouter>
              </MessagesProvider>
            </CartProvider>
          </CurrencyProvider>
        </AuthProvider>
      </ThemeProvider>
    </HelmetProvider>
  );
}
